import React, { Fragment, useEffect, useState } from "react";
import gCalendar from "../../assets/utils/images/Intagration image/google_calendar.svg"
import requestApiService from "../../services/requestApi.service";
import { confirmBox, loadConnectedIntegration } from "../../Common/Appcommon";
import { cardData } from "./Constants";
import ShowIntegrationInfo from "./ShowIntDetails.js";

const GoogleCalendar = (props) => {
    let { install, installedButton, buttonValue, name } = props;
    const [isConnected, setConnectionStatus] = useState(false);
    // const [integrationId, setintegrationId] = useState('');
    const [carddata, setData] = useState(cardData);
    const [accountInfo, setAccountInfo] = useState([]);
    let key = '';
    let foundData = carddata.find((data) => data.name === "gcalendar");
    if (foundData) {
        key = foundData.component.button.key;
    }
    //let [integrationData, setIntegrationData] = useState([]);
    let integrationData = [];
    const [tabInfo, setTabInfo] = useState([]);
    useEffect(() => {
        (async () => {
            //await onInstallGoogle();
            if(install === true){
                onInstallGoogle();
            }
            await fetchGoogleAccountDetails();
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, [install]);

    const fetchGoogleAccountDetails = async () => {
        let integrationInfo = await loadConnectedIntegration(name);
        //alert(integrationInfo);
        if (integrationInfo.length > 0) {
            setConnectionStatus(true);
            let connectedInfo = integrationInfo[0][2];
            connectedInfo = JSON.parse(connectedInfo);
            let name = connectedInfo['name'];
            let email = connectedInfo['email'];
            let IntegrationAccountInfo = [
                { type: "id", id: integrationInfo[0][0] },
                { type: "text", label: "Name", value: name },
                { type: "text", label: "Email", value: email },
            ];
            setAccountInfo(IntegrationAccountInfo);
        } else {
            integrationData = [];
            setConnectionStatus(false);
            setTabInfo([]);
        }

    };


    const onInstallGoogle = async (e) => {
        let appHost = window.location.hostname;
        let protocol = window.location.protocol;
        let callback = protocol + "//" + appHost + "/#/oauth/callback";
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "GET_OAUTH_URL",
            NAME: "GOOGLE_CALENDAR",
            CALLBACK: callback
        }
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            let authUrl = response.data;
            window.parent.location.href = authUrl;
        }
    }

    const removeIntegration = async (e, integrationId) => {
        let confirm = await confirmBox("Are you sure want to Uninstall " + integrationHeadData.name + "?", "Uninstalling the " + integrationHeadData.name + " app all actions linked to it will stop working.", 'warning', 'Uninstall', 'Cancel');
        if (!confirm) {
            return;
        }
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "REMOVE_INTEGRATION",
            ID: integrationId
        }
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            installedButton();
            // setintegrationId('');
            await fetchGoogleAccountDetails();
        }
    }

    /* const getSimpleTabs = () => {
        return tabInfo.map(({ name, biography }, index) => ({
            key: index,
            title: name,
            getContent: () => biography, // Render function if it's a component
        }));
    } */


    const integrationHeadData = {
        name: "Google Calendar",
        tag: "Calendar",
        image: gCalendar,
        installButtonText: "Install App",
        uninstallButtonText: "Uninstall App",
    };

    const integrationContent = [
        { heading: "Website", subheading: "https://calendar.google.com", type: "url" },
        { heading: "Overview", subheading: "Connect your Google Calendar with our AI Voice Agent to automate appointment scheduling and rescheduling during calls. Instantly check availability, book or reschedule meetings, and manage schedules—hands-free.", type: "text" },
        { heading: "Key Benefits", 
            subheading: [
                { 
                    // title: "AI-Powered Scheduling",
                    description: "Let AI agents book and reschedule appointments by checking your real-time Google Calendar availability." 
                },
                { 
                    // title: "Improved Accessibility", 
                    description: "Offer 24/7 appointment booking support—no more missed opportunities." 
                },
                { 
                    // title: "Seamless Synchronization", 
                    description: "Keep your calendar always up-to-date with automatic sync, preventing overlaps and double bookings." 
                },
        ], type: "list" }
    ];


    return (
        <Fragment>
            <div className="agent-details">
                <ShowIntegrationInfo
                    keyname={name}
                    headData={integrationHeadData}
                    integrationData={integrationContent}
                    isInstalled={buttonValue.includes(name)}
                    isConnected={isConnected}
                    accountInfo={accountInfo}
                    onInstall={onInstallGoogle}
                    onRemove={removeIntegration}
                />
            </div>
        </Fragment>
    );


}

export default GoogleCalendar;
